import { render, staticRenderFns } from "./ModalReviveReservation.vue?vue&type=template&id=fde70c2a"
import script from "./ModalReviveReservation.vue?vue&type=script&lang=js"
export * from "./ModalReviveReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports